import React__default from 'react';
import { css } from '@emotion/css';
import { AuthMethodSettings } from './auth-method/AuthMethodSettings.js';
import { TLSSettings } from './tls/TLSSettings.js';
import '@grafana/ui';
import { CustomHeaders } from './custom-headers/CustomHeaders.js';
import { ConfigSection } from '../ConfigSection/ConfigSection.js';
import '@grafana/data';

const Auth = ({
  selectedMethod,
  mostCommonMethod,
  visibleMethods,
  defaultOptionsOverrides,
  customMethods,
  onAuthMethodSelect,
  basicAuth,
  TLS,
  customHeaders,
  readOnly = false
}) => {
  const styles = {
    container: css({
      maxWidth: 578
    })
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: styles.container }, /* @__PURE__ */ React__default.createElement(ConfigSection, { title: "Authentication" }, /* @__PURE__ */ React__default.createElement(
    AuthMethodSettings,
    {
      selectedMethod,
      mostCommonMethod,
      customMethods,
      visibleMethods,
      defaultOptionsOverrides,
      onAuthMethodSelect,
      basicAuth,
      readOnly
    }
  ), TLS && /* @__PURE__ */ React__default.createElement(TLSSettings, { ...TLS, readOnly }), customHeaders && /* @__PURE__ */ React__default.createElement(CustomHeaders, { ...customHeaders, readOnly })));
};

export { Auth };
//# sourceMappingURL=Auth.js.map
